import { create } from "zustand";
import {  request } from "../utils";

interface Currency {
  name: string;
  abbr: string;
  symbol: string;
  flag: string;
  displayRate: number;
}

interface CurrencyRate {
  _id: string;
  fromCurrency: Currency;
  toCurrency: Currency;
  rate: number;
  minimumAmount: number;
}

interface IndicativeRateStore {
  rates: CurrencyRate[];
  loading: boolean;
  hasLoaded: boolean;
  error: string | null;
  fetchRates: () => Promise<void>;
}

export const useIndicativeRateStore = create<IndicativeRateStore>((set) => ({
  rates: [],
  loading: false,
  hasLoaded: false,
  error: null,
  fetchRates: async () => {
      try {
        // setLoading(true);
        set({ loading: true });
        const response = await request.get({
          url: "/utility/exchange-rates",
        });

        const rawRates = response.data as any[];

        const formattedRates = rawRates.map((rate) => ({
          ...rate,
          fromCurrency: {
            ...rate.fromCurrency,
            displayRate: Number(rate.fromCurrency.displayRate),
          },
          toCurrency: {
            ...rate.toCurrency,
            displayRate: Number(rate.toCurrency.displayRate),
          },
        }));

        set({
            rates: formattedRates,
            loading: false,
            hasLoaded: true
        })

      } catch (err) {
        set({ error: "Error fetching rates. Please try again later." });
        console.error("Error fetching rates:", err);
      } finally {
        set({ loading: false });
      }
    },

    
})); 